import api from "./client";

export async function listPaperReservations(params = {}) {
  const res = await api.get("/paper-reservations", { params });
  return res.data.data;
}

export async function createPaperReservation(payload) {
  const res = await api.post("/paper-reservations", payload);
  return res.data.data;
}

export async function updatePaperReservation(id, payload) {
  const res = await api.put(`/paper-reservations/${id}`, payload);
  return res.data.data;
}

export async function cancelPaperReservation(id) {
  const res = await api.delete(`/paper-reservations/${id}`);
  return res.data.data;
}

export async function listAvailablePaperLots(params = {}) {
  const res = await api.get("/paper-reservations/available-lots", { params });
  return res.data.data.items;
}

export async function listAvailablePaperLotsPaged(params = {}) {
  const res = await api.get("/paper-reservations/available-lots", { params });
  return res.data.data;
}

export async function importPaperReservations(rows) {
  const res = await api.post("/paper-reservations/import", rows);
  return res.data.data;
}
